<template>
  <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    fixed
    :dark="$vuetify.dark"
    app
    v-model="drawer"
    width="260"
  >
    <v-toolbar color="primary darken-1" dark>
      <img v-bind:src="computeLogo" height="36" alt="Omnic3 Dashboard">
      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down">Mosala</span>
      </v-toolbar-title>
    </v-toolbar>
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-list dense expand>
        <template v-for="(item, i) in menus">
          <!--group with subitems-->
          <v-list-group
            v-if="item.items"
            :key="item.name"
            :group="item.group"
            :prepend-icon="item.icon"
            no-action="no-action"
          >
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }} </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(subItem, i) in item.items">
              <!--sub group-->
              <v-list-group
                v-if="subItem.items"
                :key="subItem.name"
                :group="subItem.group"
                sub-group="sub-group"
              >
                <v-list-tile slot="activator" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-for="(grand, i) in subItem.children"
                  :key="i"
                  :to="genChildTarget(item, grand)"
                  :href="grand.href"
                  ripple="ripple"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ grand.title }} </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <!--child item-->
              <v-list-tile
                v-else
                :key="i"
                :to="genChildTarget(item, subItem)"
                :href="subItem.href"
                :disabled="subItem.disabled"
                :target="subItem.target"
                ripple="ripple"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>{{ subItem.title }}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
                <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                <v-list-tile-action v-if="subItem.action">
                  <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list-group>
          <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="i"></v-divider>
          <!--top-level link-->
          <!--   :to="!item.href ? { name: item.name } : null" -->
          <v-list-tile
            v-else
           
            :href="item.href"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="item.name" 
            @click="TargetFun(item.name,item.dispatch)"
          >
         <!--   @click="href_link(item)" -->
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}  </v-list-tile-title>
            </v-list-tile-content>
            <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
            <v-list-tile-action v-if="item.subAction">
              <v-icon class="success--text">{{ item.subAction }} </v-icon>
            </v-list-tile-action>
            <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
          </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
//import menu from "@/api/menu";
import menu_serviteur from "@/api/menu_serviteur";
import menu_admin_ecc from "@/api/menu_admin_ecc";
import menu_admin_bima from "@/api/menu_admin_bima";
import menu_church_admin from "@/api/menu_church_admin";
import menu_employee from "@/api/menu_employee";
import menu_merchants from "@/api/menu_merchants";
import menu2 from "@/api/menu2";
import { auth } from "@/api/firebaseInit";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
//import firebase from "firebase";
export default {
  name: "app-drawer",
  components: {
    VuePerfectScrollbar
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    mini: false,
    drawer: true,
    scrollSettings: {
      maxScrollbarLength: 160
    }
  }),
     /* created() {  
    this.created_by_id = firebase.auth().currentUser.uid;
     this.created_by = firebase.auth().currentUser.displayName;
  },*/
  computed: {

         type_r() {
      let user = this.$store.getters.signinUser;
      let type = user.type;
      return type;
    },

          congregation_r() {
      let user = this.$store.getters.signinUser;
      let congregation = user.congregation;
      return congregation;
    },

 
    computeGroupActive() {
      return true;
    },
    computeLogo() {
      return "/static/m.png";
    },

    sideToolbarColor() {
      return this.$vuetify.options.extra.sideNav;
    },

            menus() {
             
      let menus = menu_serviteur;
      if(this.type_r == 'S'){
      
        menus =menu_serviteur
      } 
      else if (this.type_r =='A' ) {
       if(this.congregation_r =='bima')
        menus = menu_admin_bima;
         else if (this.congregation_r =='ecc'){
           menus = menu_admin_ecc
         }
      } 
      /*
      else if(this.type === "church_admin") {
        menus = menu_church_admin;
      } else if(this.type === "employee") {
         menus = menu_employee;
      } else if(this.type === "merchants") {
         menus =  menu_merchants;
      }*/
      return menus;
    },
  },
  created() {
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.drawer = !this.drawer;
    });
  },

  methods: {

  TargetFun(name,dispatch){
        
         if(dispatch != null) {
         this.$store.dispatch(dispatch)
         }
        //  console.log(name+dispatch)
          this.$router.push({name:''+name});
     
    },
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    }
  }
};
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';
#appDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 48px);
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppDrawer.vue